import { shallowEqual } from 'react-redux';
import { Navigate, Outlet } from 'react-router';
import { selectUser } from 'ducks/user/selectors';
import { AUTH, PUBLIC } from 'router/routes';
import { useAppSelector } from 'store/hooks';

import { Loading } from 'components/loading/Loading';

import cn from 'templates/Template.module.scss';

export default () => {
  const { token, email_verified, two_factor, two_factor_expiration_date } = useAppSelector(
    selectUser,
    shallowEqual
  );

  if (!token) {
    return <Navigate to={PUBLIC.LOGIN.path} replace />;
  }

  if (token && email_verified && !two_factor) {
    return <Navigate to={AUTH.EMAIL.path} replace />;
  }

  if (token && two_factor && !two_factor_expiration_date) {
    return <Navigate to={AUTH.TWO_FACTOR.path} replace />;
  }

  return (
    <div className={cn.public}>
      <Outlet />
      <Loading />
    </div>
  );
};
